
import EnhancedRecentActivities from "./EnhancedRecentActivities";

const RecentActivities = () => {
  return <EnhancedRecentActivities />;
};

export default RecentActivities;
